import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";

function* getGame(action) {
    try {
        const gameResponse = yield call(() =>
            gamesAPI.getGame(action.payload.gameId)
        );

        yield put({
            type: GamesActionTypes.GET_GAME_SUCCESS,
            payload: gameResponse.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game info.");

        yield put({
            type: GamesActionTypes.GET_GAME_FAIL,
            message: e.message
        });
    }
}

export function* getGameWatcher() {
    yield takeLatest(GamesActionTypes.GET_GAME, getGame);
}
